import { Ref } from 'vue';

export function appendClipboard(competitionId: Ref) {
  document.addEventListener('copy', (event: ClipboardEvent) => {
    const selection = window.getSelection();
    const extra = `The above results have been taken from the PSSA scoreboard, to see the latest scores and competition history visit: ${window.location.origin}/competition/${competitionId.value}`;

    try {
      event.clipboardData?.setData('text/plain', `${selection}\n\n${extra}`);
    } catch (error) {
      throw new Error('Clipboard copy');
    }

    event.preventDefault();
  });
}
